export default "__VITE_ASSET__20e03eb8__"